import { c as _c } from "react/compiler-runtime";
import { useWallet } from "@solana/wallet-adapter-react";
import bs58 from "bs58";
import { useCallback } from "react";
import { SignatureError } from "../../lib/errors";
// Type guard to check if adapter has signMessage method
const hasSignMessage = adapter => {
  return adapter != null && typeof adapter === "object" && "signMessage" in adapter && typeof adapter.signMessage === "function";
};
export const useSvmSignFunction = () => {
  const $ = _c(2);
  const {
    signMessage
  } = useWallet();
  let t0;
  if ($[0] !== signMessage) {
    t0 = async t1 => {
      const {
        message,
        connector
      } = t1;
      const solanaAdapter = connector?.baseConnector;
      if (hasSignMessage(solanaAdapter)) {
        ;
        try {
          const messageBuffer = new TextEncoder().encode(message);
          const signature = await solanaAdapter.signMessage(messageBuffer);
          return bs58.encode(signature);
        } catch (t2) {
          const _error = t2;
        }
      }
      if (!signMessage) {
        throw new SignatureError(new Error("signMessage is not available"));
      }
      const messageBuffer_0 = new TextEncoder().encode(message);
      const signature_0 = await signMessage(messageBuffer_0);
      return bs58.encode(signature_0);
    };
    $[0] = signMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sign = t0;
  return sign;
};